import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import './MonitoringBahan.css'; // Import the CSS file

// Define a threshold for low stock warning
const LOW_STOCK_THRESHOLD = 10; // Example: Highlight if stock is 10 or less

// Helper to format Firestore Timestamp to readable date string
const formatDate = (timestamp) => {
  if (timestamp instanceof Timestamp) {
    return timestamp.toDate().toLocaleDateString('id-ID');
  }
  return typeof timestamp === 'string' ? timestamp : 'N/A';
};

const MonitoringBahan = () => {
  const [bahanList, setBahanList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch all materials
  const fetchBahan = async () => {
    setLoading(true);
    setError('');
    try {
      const bahanRef = collection(db, 'bahan');
      const q = query(bahanRef, orderBy('nama')); // Order by name
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      setBahanList(data);
    } catch (err) {
      console.error("Error fetching materials:", err);
      setError('Gagal memuat data bahan.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBahan();
  }, []);

  // Function to determine stock status class
  const getStockStatusClass = (stock) => {
    const currentStock = Number(stock);
    if (isNaN(currentStock)) return ''; // No class if stock is not a number
    if (currentStock <= 0) return 'out-of-stock';
    if (currentStock <= LOW_STOCK_THRESHOLD) return 'low-stock';
    return ''; // Normal stock
  };

  return (
    <div className="monitoring-bahan-container">
      <h2>Monitoring Stok Bahan</h2>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading-message">Memuat data stok bahan...</div>
      ) : (
        <div className="monitoring-bahan-table-container">
          <table className="monitoring-bahan-table">
            <thead>
              <tr>
                <th>Nama Bahan</th>
                <th>Kode</th>
                <th>Stok Saat Ini</th>
                <th>Satuan</th>
                <th>Lokasi</th>
                <th>Tanggal Kadaluarsa</th>
                {/* Add other relevant columns if needed */}
              </tr>
            </thead>
            <tbody>
              {bahanList.map((bahan) => (
                <tr key={bahan.id} className={getStockStatusClass(bahan.stok)}>
                  <td>{bahan.nama || 'N/A'}</td>
                  <td>{bahan.kode || 'N/A'}</td>
                  <td>{bahan.stok}</td>
                  <td>{bahan.satuan || 'N/A'}</td>
                  <td>{bahan.lokasi || 'N/A'}</td>
                  <td>{formatDate(bahan.expiry)}</td>
                </tr>
              ))}
              {bahanList.length === 0 && !loading && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center' }}>Tidak ada data bahan.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MonitoringBahan;
